import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UserSecurityIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H11M15.5 15L17 14.5V17.5C17 18.5 16.5 19.5 15.5 20C14.5 19.5 14 18.5 14 17.5V14.5L15.5 15Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

UserSecurityIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UserSecurityIcon);
